import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "list table-scrollbar mx-auto my-3",
  style: {"width":"95%"}
}
const _hoisted_2 = { class: "my-4" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import TableContent from '@/components/DailyReportEdit/Combine/TableContent.vue';
import TableHeader from "@/components/DailyReportEdit/Combine/TableHeader.vue";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { ref, computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryPlanList',
  props: {
    modelValue: {},
    deliveryPlans: {},
    page: {},
    totalPage: {}
  },
  emits: ['update:modelValue', 'updatePage'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const currentPage = ref<number>(1);

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

watch(() => currentPage.value, (newPage) => {
  emits("updatePage", newPage);
})

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_table, null, {
      default: _withCtx(() => [
        _createVNode(TableHeader),
        _createVNode(TableContent, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          deliveryPlans: __props.deliveryPlans
        }, null, 8, ["modelValue", "deliveryPlans"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PaginateWithCount, {
        class: "justify-end",
        totalPage: props.totalPage,
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
        showItemCount: false
      }, null, 8, ["totalPage", "modelValue"])
    ])
  ]))
}
}

})